import { useAuthStore } from '~/stores/auth'
import { defineNuxtRouteMiddleware } from 'nuxt/app'
import dayjs from 'dayjs'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    const authStore = useAuthStore()

    const isInvalid = !authStore.hasAdminRole

    if (
      to.name === 'admin-login-as-userId' &&
      isInvalid &&
      Object.keys(to.query).length > 0
    ) {
      const timestamp = to.query.ts as string
      const checksum = to.query.c
      const expectedChecksum = btoa(`${to.params.userId}-${timestamp}`)

      const parsedTimeStamp = dayjs.unix(parseInt(timestamp)).tz('Europe/Amsterdam')

      if (
        checksum === expectedChecksum &&
        parsedTimeStamp.isAfter(dayjs().subtract(5, 'minutes')) &&
        parsedTimeStamp.isBefore(dayjs().add(1, 'minute'))
      ) {
        // Valid admin request
        return navigateTo({
          name: 'login',
          query: { redirect: to.path }
        })
      }
    }

    if (isInvalid) {
      showError({
        status: 404
      })
      return abortNavigation()
    }
  }
})
